/**
 * Font Governance - Single source of truth for typography
 * 
 * The app uses ONLY Titillium Web as the default font family.
 * This is enforced at the governance level and cannot be overridden by user preferences.
 * 
 * All font configuration should reference this module.
 */

/**
 * Define the application's canonical font family
 * This is the ONE font used throughout the entire application
 */
export const DEFAULT_FONT_FAMILY = "'Titillium Web', 'Inter', system-ui, sans-serif";

/**
 * CSS font stack applied to the root element
 * Used in global.css and applied dynamically via JavaScript
 */
export const FONT_STACK = DEFAULT_FONT_FAMILY;

/**
 * Apply the canonical font to the document root
 * Called during initialization and whenever appearance is updated
 */
export function applyCanonicalFont() {
  if (typeof document === 'undefined') return;
  
  const root = document.documentElement;
  
  try {
    root.style.setProperty('--font-sans', DEFAULT_FONT_FAMILY);
    document.body.style.fontFamily = DEFAULT_FONT_FAMILY;
  } catch (e) {
    console.error('[fontGovernance] Failed to apply canonical font:', e);
  }
}

/**
 * Preload Titillium Web font from Google Fonts
 * This ensures the font loads quickly without FOUT (Flash of Unstyled Text)
 */
export function preloadTitilliumFont() {
  if (typeof document === 'undefined') return;
  
  // Check if already loaded
  const key = 'Titillium+Web';
  if (document.querySelector(`link[data-google-font="${key}"]`)) {
    return;
  }
  
  try {
    const href = `https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;600;700&display=swap`;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-google-font', key);
    document.head.appendChild(link);
  } catch (e) {
    console.error('[fontGovernance] Failed to preload font:', e);
  }
}
